<template>
    <UiHeroCardLayoutContainer :blok="blok" />
</template>

<script setup lang="ts">
import type { IHeroCardLayout } from '@nuxt-monorepo/ui/types/components/HeroCardLayout';

defineProps<{ blok: IHeroCardLayout }>();
</script>

<style scoped lang="postcss">
.hero-card-layout {
    :deep(.hero-card-layout-header) {
        @apply min-h-[--background-image-size] p-0 pt-8;
        background: var(--jp-background-desktop-image) no-repeat center var(--jp-background-vertical-offset);
        background-repeat: repeat-x;

        @media (max-width: theme('screens.md')) {
            background: var(--jp-background-desktop-image) no-repeat center var(--jp-background-mobile-vertical-offset);
        }

        img {
            @apply min-h-full w-full object-cover xl:object-contain;
        }

        .content-container {
            @apply max-w-[1120px] pt-2;

            .title-wrap,
            .subtitle-wrap {
                @apply px-6;
            }

            .title,
            .subtitle {
                @apply text-[100%];
            }
        }
    }

    :deep(.hero-card-layout__content) {
        @apply max-w-[1120px] px-0 pb-12 lg:px-4;
        .hero-card-layout__content-card {
            @apply px-0 max-w-[1120px] bg-inherit gap-y-8 shadow-none relative;

            .ui-simple-rich-text {
                @apply bg-white py-4 px-8;
            }
        }
    }

    :deep(.hero-image-wrapper) {
        @apply hidden;
    }
}
</style>
